<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('instances')"
      :columns="columns"
      :column_search="true"
      resource_url="/ngine/workspace/instance/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <instance-modal ref="instance_modal" />
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date,
  format_currency,
} from "@/utils";
import InstanceModal from "../instance_modal/Index.vue";

export default {
  name: "NgineVariableSetDatatable",
  components: { GenericTable, InstanceModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("data"),
          searchable: false,
          width: "15%",
          data: (row) => {
            // return format_date(row.date);
            return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.instance_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    remove(process) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete instance?"),
        v,
        () => {
          del("/ngine/workspace/instance", { uuid: process.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
